import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommentIdeaService, CommentService } from '@arkius/shared-api';
import { take } from 'rxjs';
import { PropositionMenuOption } from '../proposition-menu/proposition-menu.component';
import { Router } from '@angular/router';
import {
  AlertController,
  ModalController,
  NavController,
} from '@ionic/angular';
import { ModerateReplyModalComponent } from '../../modals/moderate-reply-modal/moderate-reply-modal.component';
import { environment } from '@shared-envs';

@Component({
  selector: 'ark-lib-reply',
  templateUrl: './reply.component.html',
  styleUrl: './reply.component.css',
})
export class ReplyComponent implements OnInit {
  @Input() item: any;
  @Input() entityType!: 'problem' | 'idea' | 'solution' | 'thinkTank';
  @Input() timelineCard = false;

  @Output() voteChanged = new EventEmitter<void>();
  @Output() clicked = new EventEmitter<void>();
  @Output() replyClicked = new EventEmitter<void>();

  @Output() downvoted = new EventEmitter<any>();
  @Output() upvoted = new EventEmitter<any>();
  @Output() editReply = new EventEmitter<any>();
  @Output() replyDeleted = new EventEmitter<void>();

  isEditingReply: boolean = false;
  updatedReply!: string;

  menuOptions: PropositionMenuOption[] = [];

  constructor(
    private router: Router,
    private navController: NavController,
    private commentService: CommentService,
    private alertController: AlertController,
    private modalCtrl: ModalController,
    private commentIdeaService: CommentIdeaService,
  ) {}

  ngOnInit() {
    if (this.entityType === 'idea' || this.entityType === 'problem') {
      this.menuOptions = [];
      return;
    }

    if (this.item.isMine && !this.item.isModerated) {
      this.menuOptions = [
        {
          name: 'Edit Reply',
          icon: 'edit',
          handler: () => this.toggleEditMode(),
        },
        {
          name: 'Delete Reply',
          icon: 'trash',
          handler: () => this.deleteReply(),
        },
      ];
    } else if (!this.item.isMine) {
      this.menuOptions.push(
        {
          name: 'Report illegal content',
          icon: 'report-flag',
          handler: () =>
            this.navController.navigateForward(
              `/report/${this.item.commentReplyId}/reply/illegal-content`,
            ),
        },
        {
          separatorName: 'Moderate',
        },
        // {
        //   name: 'Submit as inaccurate',
        //   icon: 'report-inaccurate',
        //   handler: () =>
        //     this.navController.navigateForward(
        //       `/report/${this.item.commentReplyId}/reply/inaccurate`
        //     ),
        // },
        {
          name: 'Submit as inappropriate',
          icon: 'report-inappropriate',
          handler: () =>
            this.navController.navigateForward(
              `/report/${this.item.commentReplyId}/reply/inappropriate`,
            ),
        },
      );
    }
  }

  upvote(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.item.isMine) return;

    this.upvoted.emit(this.item);
    environment.log(this.item);
  }

  downvote(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.item.isMine) return;

    this.downvoted.emit(this.item);
  }

  toggleReply(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.replyClicked.emit();
  }

  onCardClick() {
    if (this.timelineCard) {
      this.clicked.emit();
    }
  }

  onNicknameClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    this.router.navigate([
      `/account/profile/${this.item.createdByUserId}/solutions`,
    ]);
  }

  toggleEditMode() {
    this.isEditingReply = !this.isEditingReply;

    if (this.isEditingReply) {
      this.updatedReply = this.item.description;

      const replyId =
        this.entityType === 'idea'
          ? this.item.commentReplyIdeaId
          : this.item.commentReplyId;

      this.editReply.emit({
        replyId,
        description: this.item.description,
      });
    }
  }

  deleteReply() {
    this.alertController
      .create({
        header: 'Confirm Delete',
        message:
          'Are you sure you want to delete this reply? This cannot be undone.',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              environment.log('Delete reply cancelled.');
            },
          },
          {
            text: 'Delete',
            handler: () => {
              if (this.entityType !== 'idea') {
                this.commentService
                  .apiV5CommentCommentReplyIdDelete(this.item.commentReplyId)
                  .pipe(take(1))
                  .subscribe({
                    next: (response) => {
                      environment.log('Reply deleted successfully:', response);
                      this.replyDeleted.emit();
                    },
                    error: (error) => {
                      console.error('Failed to delete reply:', error);
                    },
                  });
              } else {
                this.commentIdeaService
                  .apiV5CommentIdeaCommentIdeaReplyIdDelete(
                    this.item.commentIdeaReplyId,
                  )
                  .pipe(take(1))
                  .subscribe({
                    next: (response) => {
                      environment.log('Reply deleted successfully:', response);
                      this.replyDeleted.emit();
                    },
                    error: (error) => {
                      console.error('Failed to delete reply:', error);
                    },
                  });
              }
            },
          },
        ],
      })
      .then((alert) => {
        alert.present();
      });
  }

  async openModerateReplyModal() {
    const modal = await this.modalCtrl.create({
      component: ModerateReplyModalComponent,
      componentProps: {
        item: this.item,
      },
    });

    const modalElement = modal.shadowRoot?.querySelector(
      '.modal-wrapper',
    ) as HTMLElement;
    if (modalElement) {
      modalElement.style.width = '90%';
      modalElement.style.borderRadius = '8px';
    }

    await modal.present();
    await modal.onDidDismiss();
  }
}
